import mapboxgl from '!mapbox-gl';  // eslint-disable-line import/no-webpack-loader-syntax


class clickableMarker extends mapboxgl.Marker {

	/*
	 necessary otherwise forms inside the marker element will not work, doe to mousedown.preventDefault !! 
	 */
	noListeners(){
		
		let newSubmit = this._element.cloneNode(true);
		this._element = newSubmit;
		this._element.addEventListener("keydown", (e)=>{e.stopPropagation();});
		this._element.addEventListener("keyup", (e)=>{e.stopPropagation();});
		this._element.addEventListener("mousedown", (e)=>{e.stopPropagation();});
		this._element.addEventListener("mouseup", (e)=>{e.stopPropagation();});
		return this;
	}
	
	onClick(handleClick) {
		this._handleClick = handleClick;
		return this;
	}
	onKeyPress(handlekp) {
		this._onKeyPress = handlekp;
		return this;
	}
	onKeyUp(handlekp) {
		this._onUp = handlekp;
		return this;
	}

	_onMapClick(e) {
		e.originalEvent.stopPropagation();
		const targetElement = e.originalEvent.target;
		const element = this._element;

		if (this._handleClick && (targetElement === element || element.contains((targetElement)))) {
			this._handleClick(element, targetElement);
		}
	}
};
export default clickableMarker